module.exports = __webpack_public_path__ + "img/arrow-prev.60c48364.svg";